import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  MdLocationOn,
} from 'react-icons/md';
import _ from 'lodash';

const Marker = ({
  text, markerKey, selected, hovered, onClick, pageNumber, currency,
  onMouseEnter, onMouseLeave, isAgentPreferredHotel, hasRateCodeMatch,
  isAnyRateCodeSelected, doShowMapHighlighting,
}) => {
  const getMarkerClasses = () => {
    if (!doShowMapHighlighting || hovered) {
      return '';
    }
    if (isAgentPreferredHotel) {
      return 'bg-green-300 z-30';
    }
    if (!isAnyRateCodeSelected) {
      return '';
    }
    if (hasRateCodeMatch) {
      return 'bg-yellow-200 z-20';
    }
    return 'bg-red-200';
  };

  const className = clsx(
    'border-theme border-2 z-10 text-xs p-1 font-bold inline whitespace-no-wrap rounded-full relative hover:z-30 hover:bg-black hover:text-white ',
    selected ? 'text-theme z-20' : 'text-black',
    hovered ? 'bg-black text-white z-30' : 'bg-white',
    getMarkerClasses(),
  );

  const handleClick = (e) => {
    e.preventDefault();
    onClick(markerKey, pageNumber);
  };

  return (
    <a
      className={_.isNumber(text) ? className : undefined}
      href="#"
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {_.isNumber(text) ? `${currency}${text.toFixed(2)}` : <MdLocationOn size="32" fill="#f56565" className="inline-block -mt-1" />}
    </a>
  );
};

Marker.propTypes = {
  text: PropTypes.number,
  markerKey: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  hovered: PropTypes.bool,
  onClick: PropTypes.func,
  pageNumber: PropTypes.number,
  currency: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  lat: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  lng: PropTypes.number.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  isAgentPreferredHotel: PropTypes.bool,
  hasRateCodeMatch: PropTypes.bool,
  isAnyRateCodeSelected: PropTypes.bool,
  doShowMapHighlighting: PropTypes.bool,
};

Marker.defaultProps = {
  selected: false,
  hovered: false,
  onClick: undefined,
  pageNumber: 0,
  text: undefined,
  currency: '$',
  onMouseEnter: () => { },
  onMouseLeave: () => { },
  isAgentPreferredHotel: false,
  hasRateCodeMatch: false,
  isAnyRateCodeSelected: false,
  doShowMapHighlighting: false,
};
export default React.memo(Marker);
